module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-05-4d334d5573bb5bb57a3482a7e7112d33.jpg";